module Sm.UI.App

open MobF

open Sm.Service
open Sm.Service.App
open Sm.Service.Session

open Sm.UI.Login

type Screen =
    | Login of LoginModel
    | Loading
    | Warning of string
    | Main of Main.Type

type State = {
    Args: Map<string, string>
    Session: SessionModel
    Halted: bool
}

type Msg =
    | Halt

type IComputed =
    abstract Screen: Screen

type AppModel = Model<State, Msg, IComputed>

let create client args : AppModel =
    let init post =
        CriticalError.instance |> Subscribe.auto
            (fun x -> x.Error)
            (function
                | None -> ()
                | Some _ -> post Halt
            )

        let session = Session.create client
        {
            Args = args
            Session = session
            Halted = false
        }

    let update state = function
        | Halt -> { state with Halted = true }

    let compute state =
        { new IComputed with
            member _.Screen =
                match state.Session.State with
                | Inactive ->
                    let model = Login.create client state.Session state.Args
                    Login model

                | Resuming ->
                    Loading

                | Active ctx ->
                    let model = Main.create ctx state.Session
                    Main model

                | Blocked ->
                    Warning "The app was unable to start, please clear your cache and refresh. If the problem persists, please contact support."
        }

    Model.useInitWithPost init
    |> Model.andUpdate update
    |> Model.createWithComputed compute
